import { Injectable } from "../../../lib/web/reflection/injectable";
import { RouterService } from "./router.service";

@Injectable({ type: 'singleton' })
export class DataEventService {

    public constructor(private _routerService: RouterService) {
        window.dataLayer = window.dataLayer || [];
    }   

    public register(): void {
        this.addDataEvent('click.event', {
            eventName: 'acceso_formulario',
            section: this._routerService.previousUrl || '/'
        });
    }   

    public startRegister(): void {
        this.addDataEvent('click.event', {
            eventName: 'rellenar_formulario',
            section: location.pathname
        });
    }

    public completeRegister(): void {
        this.addDataEvent('click.event', {
            eventName: 'complete_registration',
            section: location.pathname
        });
    }

    public signIn(): void {
        this.addDataEvent('click.event', {
            eventName: 'iniciar_sesion',
            section: this._routerService.previousUrl || '/'
        });
    }

    public signInSend(): void {
        this.addDataEvent('click.event', {
            eventName: 'login_send',
            section: location.pathname
        });
    }

    public signInOk(): void {
        this.addDataEvent('click.event', {
            eventName: 'login',
            section: location.pathname
        });
    }

    public signInFail(): void {
        this.addDataEvent('click.event', {
            eventName: 'login_fail',
            section: location.pathname
        });
    }

    public menuNavigate(menuName: string, parentMenuName?: string): void {
        this.addDataEvent('navigation.event', {
            eventName: 'menu',
            section: location.pathname,
            category: `${parentMenuName ? `${parentMenuName}-` : ''}${menuName}`,
        });
    }

    public viewContent(name: string): void {
        this.addDataEvent('content.event', {
            eventName: 'contenido',
            section: location.pathname,
            category: name
        });
    }   

    public videoStart(videoId: string): void {
        this.addDataEvent('content.event', {
            eventName: 'video_start',
            section: location.pathname,
            category: videoId
        });
    }

    public favorite(added: boolean, slug: string): void {
        this.addDataEvent('content.event', {
            eventName: added ? 'favorite' : 'unfavorite',
            section: location.pathname,
            category: slug
        });
    }

    public shareVideo(platform: string): void {
        this.addDataEvent('content.event', {
            eventName: 'share_video',
            section: location.pathname,
            category: platform
        });
    }

    public videoAction(videoId: string, action: 'play' | 'pause' | 'video_completed'): void {
        this.addDataEvent('content.event', {
            eventName: action,
            section: location.pathname,
            category: videoId
        });
    }

    public search(term: string): void {
        this.addDataEvent('navigation.event', {
            eventName: 'buscador',
            section: location.pathname,
            category: term
        });
    }

    public signOut(): void {
        this.addDataEvent('click.event', {
            eventName: 'cerrar_sesion',
            section: location.pathname
        });
    }

    public completeRegistration(userId: string, loginType: 'email'): void {
        this.addDataEvent('complete_registration', {
            login_type: loginType,
            user_id_login: userId
        });
    }

    public loginTry(): void {
        this.addDataEvent('login_try');
    }

    public loginSend(loginType: 'email'): void {
        this.addDataEvent('login_send', 
        {
            login_type: loginType
        });
    }

    public login(userId: string, loginType: 'email'): void {
        this.addDataEvent('login', 
        {            
            login_type: loginType,
            user_id_login: userId
        });
    }

    public loginFail(loginType: 'email'): void {
        this.addDataEvent('login_fail', 
        {
            login_type: loginType
        });
    }

    public textTrackEnabled(id: string, name: string, disciplines: string[], typology: string, language: string): void {
        this.addDataEvent('video', 
        {
            video_action: 'enable subtitles',
            video_id: id,
            video_name: name,
            video_theme: (disciplines || []).join(','),
            video_type: typology,
            language_subtitle: language
        });
    }

    public share(action: string, id: string, name: string, disciplines: string, typology: string, socialNetwork: string, location: string): void {
        if (action == 'share_video') {
            this.addDataEvent('video', 
            {
                video_action: action,
                video_id: id,
                video_name: name,
                video_theme: disciplines,
                video_type: typology,
                social_network: socialNetwork,
                location
            });
        }
        else if (action == 'share_collection') {
            this.addDataEvent('collection', 
            {
                collection_action: action,
                collection_id: id,
                collection_landing_name: name,
                collection_theme: disciplines,
                collection_type: typology,
                social_network: socialNetwork,
                location
            });
        }
        else if (action == 'share_partner_landing') {
            this.addDataEvent('partner_landing', 
            {
                partner_landing_action: action,
                partner_landing_id: id,
                partner_landing_name: name,
                social_network: socialNetwork,
                location
            });
        }
    }

    public addFavorite(type: string, id: string, name: string, disciplines: string, typology: string): void {
        if (type == 'video') {
            this.addDataEvent('video',
            {
                video_action: 'favorite',
                video_id: id,
                video_name: name,
                video_theme: disciplines,
                video_type: typology
            });
        }
        else if (type == 'collection') {
            this.addDataEvent('collection', 
            {
                collection_action: 'favorite',
                collection_id: id,
                collection_landing_name: name,
                collection_theme: disciplines,
                collection_type: typology
            });
        }
        else if (type == 'partner_landing') {
            this.addDataEvent('partner_landing', 
            {
                partner_landing_action: 'favorite',
                partner_landing_id: id,
                partner_landing_name: name
            });
        }
    }

    public shareStreaming(id: string, name: string, disciplines: string[], typology: string, location: string, via: string): void {
        this.addDataEvent('video', 
        {
            video_action: 'share_streaming',
            video_id: id,
            video_name: name,
            video_theme: (disciplines || []).join(','),
            video_type: typology,
            location,
            via,
        });
    }

    public page(userId: string, type: string): void {
        window.dataLayer.push({ 
            user_login: userId ? 1: 0,
            content_group: type,
            user_id_login: userId || ''
        }); 
    }

    public openFragment(id: string, name: string, location: string): void {
        this.addDataEvent('open_fragment',  
        {
            video_id: id, 
            video_name: name, 
            location 
        });
    }

    public selectFragment(id: string, name: string, location: string, fragment: string): void {
        this.addDataEvent('select_fragment', 
        {
            video_id: id,
            video_name: name,
            location,
            fragment,
        });
    }

    public selectFilter(name: string, type: string, value: number | number[]): void {
        this.addDataEvent('select_filter', 
        {
            filter_name: name,
            filter_type: type,
            filter_value: value,
        });
    }

    public clickMenu(url: string, name: string, text: string, type: string, pageName: string, pageUrl: string): void {
        this.addDataEvent('menu',
        {
            menu_action: 'click_menu',
            menu_url: url,
            menu_name: name,
            menu_text: text,
            menu_type: type,
            menu_page: pageName,
            menu_page_url: pageUrl
        });
    }

    public onboarding(): void {
        this.addDataEvent('page.event', {
            eventName: 'pagina_virtual',
            category: 'onboarding',
        });
    }

    public onboardingQuestion(id: string): void {
        this.addDataEvent('page.event', {
            eventName: 'pagina_virtual',
            category: 'Test',
            section: id
        });
    }

     public onboardingNextQuestion(id: string, anwser: string): void {
        this.addDataEvent('click.event', {
            eventName: 'avanzar',
            category: anwser,
            section: id
        });
    }

    public onboardingResult(videoIds: string[], clusterId: number): void {
        this.addDataEvent('page.event', {
            eventName: 'pagina_virtual',
            category: 'confirmacion',
            perfil: clusterId,
            video_ids: videoIds.join(', ')
        });
    }

    public onboardingRegister(clusterId: number): void {
        this.addDataEvent('click.event', {
            eventName: 'click_intencion_registro',
            category: 'acceso_formulario',
            perfil: clusterId,
        });
    }

    public onboardingStartVideo(clusterId: number, videoId: string): void {
        this.addDataEvent('page.event', {
            eventName: 'video_start',
            category: 'confirmacion',
            perfil: clusterId,
            video_ids: videoId
        });
    }

    private addDataEvent(name: string, data?: any): void {
        window.dataLayer.push({ 
            event: name,
            ...(data || {})
        }); 
        logger.debug(`📊 event '${name}' added`, Array.from(window.dataLayer as any).last());
    }
}